import { createFileRoute, redirect } from '@tanstack/react-router';
import { getOrderPath } from '../../../../../../../../../../features/order/order-routing';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: getOrderPath({ kind: 'list', keys: { accountId: params.accountId } }) });
  },
  preload: false,
});
